"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var InvitePeople = function InvitePeople(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "InvitePeople"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "invite-people"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.82 9.040c2.488-0.011 4.5-2.031 4.5-4.52 0-2.496-2.024-4.52-4.52-4.52s-4.52 2.024-4.52 4.52v0c0 0 0 0 0 0 0 2.496 2.024 4.52 4.52 4.52 0.007 0 0.014-0 0.021-0h-0.001zM8.82 1.9c1.447 0 2.62 1.173 2.62 2.62s-1.173 2.62-2.62 2.62c-1.447 0-2.62-1.173-2.62-2.62v0c0-1.447 1.173-2.62 2.62-2.62v0zM11.66 18.1h-8c-0.8 0-1.76-0.48-1.76-1.18-0.001-0.034-0.002-0.073-0.002-0.113 0-1.112 0.452-2.119 1.182-2.847l0-0c1.396-1.145 3.201-1.839 5.167-1.839 0.194 0 0.387 0.007 0.579 0.020l-0.026-0.001c0.103-0.004 0.224-0.006 0.345-0.006 0.806 0 1.591 0.089 2.346 0.259l-0.071-0.013c0.069 0.018 0.147 0.028 0.229 0.028 0.448 0 0.824-0.306 0.93-0.721l0.001-0.007c0.017-0.067 0.027-0.145 0.027-0.224 0-0.454-0.316-0.835-0.74-0.935l-0.007-0.001c-0.866-0.204-1.861-0.321-2.883-0.321-0.062 0-0.124 0-0.186 0.001l0.009-0c-0.173-0.011-0.374-0.017-0.577-0.017-2.488 0-4.764 0.907-6.516 2.408l0.014-0.011c-1.064 1.058-1.723 2.523-1.723 4.142 0 0.070 0.001 0.139 0.004 0.208l-0-0.010c0 1.9 1.9 3.080 3.66 3.080h8c0.467-0.070 0.822-0.469 0.822-0.95s-0.354-0.88-0.817-0.949l-0.005-0.001zM19.040 14.28h-1.9v-1.9c-0.070-0.467-0.469-0.822-0.95-0.822s-0.88 0.354-0.949 0.817l-0.001 0.005v1.9h-1.9c-0.467 0.070-0.822 0.469-0.822 0.95s0.354 0.88 0.817 0.949l0.005 0.001h1.9v1.92c0.070 0.467 0.469 0.822 0.95 0.822s0.88-0.354 0.949-0.817l0.001-0.005v-1.92h1.9c0.467-0.070 0.822-0.469 0.822-0.95s-0.354-0.88-0.817-0.949l-0.005-0.001z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = InvitePeople;
exports["default"] = _default;